const MATERIAL_SYMBOL_CHECK_FONT =
    'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20,500,1,0&icon_names=check';

const ensureGoogleSymbolFont = () => {
    if (typeof document === 'undefined') {
        return;
    }

    const exists = document.head.querySelector(`link[rel="stylesheet"][href="${MATERIAL_SYMBOL_CHECK_FONT}"]`);

    if (exists) {
        return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = MATERIAL_SYMBOL_CHECK_FONT;
    document.head.appendChild(link);
};

ensureGoogleSymbolFont();
